module.exports = __webpack_public_path__ + "assets/valance-wave-scallop-selected.186061e4.svg";